module.exports = __webpack_public_path__ + "img/romperti-la-testa.12264184.jpg";